import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ContractGetCollectionByStageId, ContractGetCollectionByStageIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ContractGetCollectionByStageIdResponse, ContractGetCollectionByStageIdResponse>) => {
    return response?.data?.contracts;
}
const getError = (response?: SWRResponse<ContractGetCollectionByStageIdResponse, ContractGetCollectionByStageIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useContractsByStageId = (stageId: number, configuration?: SWRConfiguration<ContractGetCollectionByStageIdResponse, ContractGetCollectionByStageIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ContractGetCollectionByStageId({
                stageId: stageId
            });
        };
    }, [stageId])

    return useGet(request, { getData, getError }, configuration);
}

export default useContractsByStageId;